import codes from '@/f1/codes';
import _ from 'lodash';

export default {
  // components :  {},
  watch : {
    now_schedule() {
      this.refresh()
    }
  },
  name: 'Schedule',
  props: ['now_schedule', 'hide_text', 'readonly'],
  data: function () {
    return {
      schedule : [],
      codes,
      s : { time: '03:00', day: 9, h_opt: codes.WSF_SCHEDULE_i18n }, // 스케줄
      v : {},
    }
  },
  computed: {
    isFolder: function () { return this.item.child && this.item.count }
  },
  methods: {
    getName(key_text) { _.forEach(this.s.h_opt[this.i18n], data => { console.log(data); if (data.value == key_text) { this.s.name = data.text; return; } })},
    add_schedule(){ //스케줄 추가
      // name 의 경우 정보성으로 에이전트 설정과 무관

      for (let l = 0; l < this.s.h_opt[this.i18n].length; l++) {

        console.log(this.s.h_opt[this.i18n][l].value, this.s.day)

        if(this.s.h_opt[this.i18n][l].value != this.s.day) {
          continue
        }

        this.s.name = this.s.h_opt[this.i18n][l].text;
      }

      let t = this.s.time
      if(t.indexOf(':') < 0) { return this.$toastr.w("is not hh:mm time format") }
      let sch = t.split(':')
      let hour = '00'
      let min = '00'

      console.log(sch, this.s.name)

      // set hour
      if(sch[0].length > 2) { hour = sch[0].substring(0, 2) }
      else if(sch[0].length < 1) { hour = sch[0].padStart(2, '0') }
      else { hour = sch[0] }

      // set min
      if(sch[1].length > 2) { min = sch[1].substring(0, 2) }
      else if(sch[1].length < 1) { min = sch[1].padStart(2, '0') }
      else { min = sch[1] }

      console.log(`${hour}:${min}`)
      this.s.time = `${hour}:${min}`
      let schedule = { 'time' : `${hour}:${min}`, 'day' : this.s.day, 'name' : this.s.name };
      if (!this.s.time) { return this.$toastr.i('Time setting'); }
      let check_duplicate = false;
      _.forEach(this.schedule, sch => { if (_.isEqual(sch, schedule)) { check_duplicate = true; } })
      if (check_duplicate) { return this.$toastr.i('This item already exists'); }
      this.schedule.push(schedule);
      this.s.time = '03:00';
      this.s.day = 9;
      this.save()
    },
    remove_sch(i){ this.schedule.splice(i, 1); this.save() },//스케줄 지우기
    save() { this.$parent.$emit('save', this.schedule) },
    refresh() {
      console.log('schedule refreshed')
      this.schedule = this.now_schedule
    }
  },
  created: function() {   console.log('schedule.vue', 'created'); },
  destroyed: function() { console.log('schedule.vue', 'destroyed'); },
  mounted: function() {
    console.log('schedule.vue', 'mounted');
    this.refresh()
  }
}
